document.addEventListener("DOMContentLoaded", function() {
  const openBtn = document.getElementById("open-size-chart");
  const closeBtn = document.querySelector(".close-popup");
  const popup = document.getElementById("size-chart-popup");

  if (openBtn && popup) {
    openBtn.addEventListener("click", function(e) {
      e.preventDefault();
      popup.style.display = "flex";
    });
  }

  if (closeBtn && popup) {
    closeBtn.addEventListener("click", function() {
      popup.style.display = "none";
    });
  }

  // Fechar ao clicar fora do popup
  window.addEventListener("click", function(event) {
    if (event.target == popup) {
      popup.style.display = "none";
    }
  });

  // Fechar com a tecla ESC
  document.addEventListener("keydown", function(event) {
    if (event.key === "Escape" && popup.style.display === "flex") {
      popup.style.display = "none";
    }
  });
});